import * as XLSX from 'xlsx';
import {AfterViewChecked, Component, ViewChild} from '@angular/core';
import {LoadingService} from '../../../services/loading.service';
import {MatDialogRef} from '@angular/material/dialog';
import {MatStepper} from '@angular/material/typings/stepper';
import {KeyAccountSecondStepComponent} from './key-account-second-step/key-account-second-step.component';
import {StepperService} from '../../../layout/services/stepper.service';

@Component({
  selector: 'app-upload-super-market-key-account',
  templateUrl: './upload-super-market-key-account-dialog.component.html'
})
export class UploadSuperMarketKeyAccountDialogComponent implements AfterViewChecked {
  @ViewChild('secondStep', {static: true}) secondStep: KeyAccountSecondStepComponent;
  @ViewChild('stepper', {static: true}) stepper: MatStepper;

  public smKeyAccounts: any[];
  public disableButton: boolean;
  public file: any;

  constructor(private loadingService: LoadingService,
              private matDialogRef: MatDialogRef<UploadSuperMarketKeyAccountDialogComponent>,
              public stepperService: StepperService) {
    this.disableButton = true;
  }

  public ngAfterViewChecked() {
    if (this.stepper) {
      let status;
      switch (this.stepper.selectedIndex) {
        case 0:
          status = this.file === undefined;
          break;
        case 1:
          status = false;
          break;
      }
      if (status !== this.disableButton) {
        setTimeout(() => {
          this.disableButton = status;
        }, 0);
      }
    }
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  public async goToNextStep(): Promise<any> {
    if (this.stepper.selectedIndex === 0) {
      this.loadingService.show();
      setTimeout(async () => {
        const promise = new Promise((resolve) => {
          const reader: FileReader = new FileReader();
          reader.onload = (file: any) => {
            const fileName: string = file.target.result;
            const workBook: XLSX.WorkBook = XLSX.read(fileName, {
              dateNF: 'YYYY-MM-DD',
              type: 'binary'
            });
            const workSheetName: string = workBook.SheetNames[0];
            const workSheet: XLSX.WorkSheet = workBook.Sheets[workSheetName];
            const superMarketKeyAccount: any[] = XLSX.utils.sheet_to_json(workSheet, {
              header: 1,
              raw: false
            });
            superMarketKeyAccount.shift();
            this.smKeyAccounts = [];
            for (const keyAccount of superMarketKeyAccount) {
              let model;
              model = {
                  key_account_name: keyAccount[Object.keys(keyAccount)[0]],
                  sales_group_id: keyAccount[Object.keys(keyAccount)[1]],
                  payer_id: keyAccount[Object.keys(keyAccount)[2]]
                };
              this.smKeyAccounts.push(model);
            }
            resolve({});
          };
          reader.readAsBinaryString(this.file.file);
        });
        await promise;
        this.loadingService.hide();
        // @ts-ignore
        this.stepperService.goToNextStep(this.stepper);
      }, 500);
    } else {
      await this.secondStep.submitProcess();
      this.matDialogRef.close('success');
    }
  }
}
